// Accent theme handling — mirrors the data-accent themes in index.css.

export const ACCENTS = ['aurora', 'sunset', 'violet', 'ocean', 'gold'] as const;
export type Accent = (typeof ACCENTS)[number];

const STORAGE_KEY = 'audiaro_accent';
const DEFAULT_ACCENT: Accent = 'ocean';

export function getAccent(): Accent {
  const stored = localStorage.getItem(STORAGE_KEY);
  return ACCENTS.includes(stored as Accent) ? (stored as Accent) : DEFAULT_ACCENT;
}

export function applyAccent(accent: Accent) {
  document.documentElement.dataset.accent = accent;
  localStorage.setItem(STORAGE_KEY, accent);
}

export function initAccent() {
  document.documentElement.dataset.accent = getAccent();
}

/** Representative swatch colors per accent, for the theme picker. */
export const ACCENT_SWATCHES: Record<Accent, [string, string]> = {
  aurora: ['#6EE7B7', '#6366F1'],
  sunset: ['#FDBA74', '#E11D8F'],
  violet: ['#C4B5FD', '#7C3AED'],
  ocean: ['#67E8F9', '#2563EB'],
  gold: ['#ECD687', '#B08B3C'],
};
